"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { HttpClient, HttpParams, } from '@angular/common/http';
import { Auth } from '@shared/auth';
import { Observable } from 'rxjs/Observable';
import { catchError, filter, map, switchMap, withLatestFrom, } from 'rxjs/operators';
import { backend, } from './backend';
import { isDefined } from './helpers';
var ApiHttp = /** @class */ (function () {
    function ApiHttp(http, auth, datastoreConfig) {
        this.http = http;
        this.auth = auth;
        this.datastoreConfig = datastoreConfig;
    }
    ApiHttp.prototype.fetch = function (ref) {
        var _this = this;
        return Observable.of(ref).pipe(switchMap(function (_a) {
            var pathList = _a.pathList, query = _a.query;
            return Observable.of(backend[pathList[0]].fetch).pipe(filter(isDefined), map(function (fetch) { return ({
                newConfig: fetch(pathList[1], query),
                pagination: {
                    limit: query && query.limit,
                    offset: query && query.offset,
                },
            }); }));
        }), withLatestFrom(this.auth.getAuthorizationHeader()), switchMap(function (_a) {
            var _b = _a[0], newConfig = _b.newConfig, pagination = _b.pagination, authHeader = _a[1];
            var baseUrl = newConfig.isGaf
                ? _this.datastoreConfig.ajaxBaseUrl
                : _this.datastoreConfig.apiBaseUrl;
            // Add webapp=1 for tracking in the backend to API requests
            var configParams = newConfig.isGaf
                ? newConfig.params
                : __assign({}, newConfig.params, { webapp: 1 });
            var params = pagination
                ? __assign({}, configParams, { limit: pagination.limit, offset: pagination.offset }) : configParams;
            return _this.http.get(baseUrl + "/" + newConfig.endpoint, {
                headers: authHeader,
                params: _this.serialize(params),
            });
        }), catchError(function (err) {
            if (err.error instanceof Error) {
                // A client-side or network error occurred.
                return Observable.throw(err.error);
            }
            // The backend returned an unsuccessful response code.
            return Observable.throw(new Error(err.message));
        }));
    };
    ApiHttp.prototype.post = function (config, payload) {
        return this.mutate(config, { action: 'post', payload: payload });
    };
    ApiHttp.prototype.put = function (config, payload) {
        return this.mutate(config, { action: 'put', payload: payload });
    };
    ApiHttp.prototype.delete = function (config) {
        return this.mutate(config, { action: 'delete' });
    };
    ApiHttp.prototype.mutate = function (config, data) {
        var _this = this;
        return Observable.of(config).pipe(withLatestFrom(this.auth.getAuthorizationHeader()), switchMap(function (_a) {
            var newConfig = _a[0], authHeader = _a[1];
            var baseUrl = newConfig.isGaf
                ? _this.datastoreConfig.ajaxBaseUrl
                : _this.datastoreConfig.apiBaseUrl;
            var url = baseUrl + "/" + newConfig.endpoint;
            var options = { headers: authHeader };
            if (data.action === 'delete') {
                return _this.http.delete(url, options);
            }
            var body = _this.serialize(__assign({}, data.payload, newConfig.params));
            if (data.action === 'post') {
                return _this.http.post(url, body, options);
            }
            return _this.http.put(url, body, options);
        }));
    };
    ApiHttp.prototype.serialize = function (obj) {
        var params = new HttpParams();
        Object.entries(obj).forEach(function (_a) {
            var key = _a[0], value = _a[1];
            if (typeof value === 'string') {
                params = params.set(key, value);
            }
            else if (typeof value === 'number') {
                params = params.set(key, String(value));
            }
            else if (Array.isArray(value)) {
                // This type casting shouldn't be necessary but is because of a TS bug.
                // https://github.com/Microsoft/TypeScript/issues/15315
                // https://github.com/Microsoft/TypeScript/issues/7294
                // Our backend expects arrays foo=[1,2] to be encoded as foo[]=1&foo[]=2
                value.forEach(function (rawVal) {
                    // The batching of requests connatenates things with `&`.
                    return String(rawVal)
                        .split('&')
                        .forEach(function (v) { return (params = params.append(key + "[]", v)); });
                });
            }
        });
        params = params.set('compact', 'true');
        return params;
    };
    return ApiHttp;
}());
export { ApiHttp };



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-webapp-compat/webapp/src/app/@shared/datastore/api-http.service.ts.pre-build-optimizer.js